import React from 'react';
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";
import CustomActiveShapePieChart from "../charts/CustomActiveShapePieChart";
import DataTile from "../metrics/DataTile";

const TileBRSocialAllTimeExecuted =({props})=>{
    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {portfolios, entityInView, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const lastCycleId = myEntity && myEntity.settings && myEntity.settings.last_cycle_id;


    const social = myEntity
        && myEntity.cycles
        && lastCycleId
        && myEntity.cycles[lastCycleId]
        // && !loadingCycleSocial[lastCycleId]
        && myEntity.cycles[lastCycleId].social

    const allTimeTotals = lastCycleId
        // && !loadingCycleSocial[lastCycleId]
        && social
        && social.allTimeTotals;

    const numTestsSent = lastCycleId
    && social
    && social.allTimeTotals
        ? social.allTimeTotals.tests
        : null;

    const numTestsExecuted = lastCycleId
    && social
    && social.allTimeTotals
        ? social.allTimeTotals.executions
        : null;

    const hasSocialTestData = lastCycleId
        // && !loadingCycleSocial[lastCycleId]
        && social
        && allTimeTotals
        && allTimeTotals.tests !== 0;


    const showPieWith = (stateData) => {
        if (stateData && stateData[customerIdToUse] && myEntity
            // && !loadingCycleSocial[lastCycleId]
        ) {

            try {

                const arrayData = numTestsSent!== 0
                    ?[{name: "Executed", value: numTestsExecuted}, {name: "Not Executed", value: numTestsSent - numTestsExecuted}]
                    : [];

                return <div
                    className={"animated fadeIn animation-duration-7"}
                    style={{ marginTop: -40, marginBottom: -15 }}
                ><CustomActiveShapePieChart
                    data = {arrayData}
                    loading = {!arrayData}
                /></div>


            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }

    const valueFunction = (stateData) => {
        return lastCycleId
        && social
        && social.allTimeTotals
            ? social.allTimeTotals.executions
            : null;
    }

    return (
        <DataTile
            subTitle="Total Executed"
            tipText={`Number of Executions resulting from a Spearphishing Email since Social Engineering began. Executed means that we were able to execute an attack process on the recipient's host using the spearphishing payload. Some security controls can prevent this code execution, and even successfully executed payloads might not cause a breach.`}
            icon={<div
                className={"animated fadeIn animation-duration-7"}
                style={{ marginTop: -40, marginBottom: -15 }}
            ><CustomActiveShapePieChart
                data = {[]}
                // riskBy5={-1}
                loading
            /></div>}
            iconFunction = {showPieWith}
            iconClasses={" "}
            stateName="breachrisk"
            stateElement="portfolios"
            dontFetch
            // forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && social ? false : true}
            valueFunction={valueFunction}
        />
    )


}

export default TileBRSocialAllTimeExecuted;